export default __webpack_public_path__ + "fedbee778b26dce1cc21daeb57f3ea96.woff2";